import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { LIST_CATALOGS } from "./model/list-copy.ts";
import { LIST_ERROR_COPY } from "./model/list-error-copy.ts";

// D206 (ADR-006 §7): every screen and the sidebar entry need "filters"; off, the screens are
// the not-found screen and the entry is absent, so the area does not exist for the organization.
export const listBrowserModule: BrowserModule = defineBrowserModule("list")
  .withErrorCopy(LIST_ERROR_COPY)
  .withScreens({
    lists: {
      path: "/lists",
      title: phrase(LIST_CATALOGS, "listsScreenTitle"),
      layout: "app",
      flag: "filters",
      load: () => import("./ui/sections/lists-screen.tsx"),
    },
    create: {
      path: "/lists/new",
      title: phrase(LIST_CATALOGS, "newScreenTitle"),
      layout: "app",
      flag: "filters",
      load: () => import("./ui/sections/list-editor-screen.tsx"),
    },
    edit: {
      path: "/lists/:listId/edit",
      title: phrase(LIST_CATALOGS, "editScreenTitle"),
      layout: "app",
      flag: "filters",
      load: () => import("./ui/sections/list-editor-screen.tsx"),
    },
    detail: {
      path: "/lists/:listId",
      title: phrase(LIST_CATALOGS, "detailScreenTitle"),
      layout: "app",
      flag: "filters",
      load: () => import("./ui/sections/list-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "filters",
      group: "leads",
      label: phrase(LIST_CATALOGS, "navFilters"),
      href: "/lists",
      icon: "filter",
      order: 120,
      flag: "filters",
    },
  ]);
